import api from "./api";

const listarDiretorios = async () => {
    try {
        const response = await api.get("/diretorios");
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const listarDiretoriosPorIDPai = async (IDDiretorioPai, IDProcesso) => {
    try {
        const response = await api.get(`/diretorioByIDPai/${IDDiretorioPai}/${IDProcesso}`);
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const atualizarSituacaoDiretorio = async (IDDiretorio, situacao) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/situacao`, { situacao });
        return response;
    } catch (error) {
        console.error('Falha ao atualizar situação do diretório', error);
        throw error;
    }
};

const renomearDiretorio = async (IDDiretorio, nome) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/renomear`, { descricaoExibicao: nome });
        return response;
    } catch (error) {
        console.error('Falha ao renomear o diretório', error);
        throw error;
    }
};

export const diretorioService = {
    listarDiretorios,
    listarDiretoriosPorIDPai,
    atualizarSituacaoDiretorio,
    renomearDiretorio
};
